module.exports = __webpack_public_path__ + "static/travel-2-09715eae38d9168157217d8e4ed26d4b.mp4";